

















import { Component, Vue } from "vue-property-decorator";
import RequestFilters from "@/components/Requests/RequestFilters.vue";
import RequestList from "@/components/Requests/RequestList.vue";
import LoadingPanel from "@/components/LoadingPanel.vue";
import requestStore from "@/store/requestStore";
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import userStore from "@/store/userStore";

@Observer
@Component({ components: { RequestFilters, RequestList, LoadingPanel } })
export default class Requests extends Vue {
  requestStore = requestStore;
  dispose?: () => void;

  async mounted() {
    this.dispose = reaction(
      () => userStore.councilConfiguration,
      () => {
        requestStore.fetchData();
        const myFilters = this.$refs.filters as RequestFilters;
        myFilters.clearCache();
      },
      { fireImmediately: true }
    );
  }

  destroyed() {
    if (this.dispose) this.dispose();
    requestStore.reset();
  }
}
